module.exports = __webpack_public_path__ + "static/media/flask.c28251ff.svg";